import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';




const routes: Routes = [
  {path: '', loadComponent: () => import('./welcome.component').then(m => m.WelcomeComponent)},
  {
    path: 'menus/:name',
    title: 'Détails Menu',
    loadComponent: () => import('./menus/details-menus/details-menus.component').then(m => m.DetailsMenusComponent),
    data: {
      disableTitleStrategy: true
    }
  },
  {
    path: 'nos-promos/:name',
    title: 'Détails Promotion',
    loadComponent: () => import('./promos/details-promos/details-promos.component').then(m => m.DetailsPromosComponent),
    data: {
      disableTitleStrategy: true
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WelcomeRoutingModule {
}
